/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface AddNoteRequestContent
 */
export interface AddNoteRequestContent {
    /**
     * The note to be added to the player's account
     * @type {string}
     * @memberof AddNoteRequestContent
     */
    note: string;
}


/**
 * Check if a given object implements the AddNoteRequestContent interface.
 */
export function instanceOfAddNoteRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "note" in value;
    return isInstance;
}

export function AddNoteRequestContentFromJSON(json: any): AddNoteRequestContent {
    return AddNoteRequestContentFromJSONTyped(json, false);
}

export function AddNoteRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddNoteRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'note': json['note'],
    };
}

export function AddNoteRequestContentToJSON(value?: AddNoteRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'note': value.note,
    };
}

